export default __webpack_public_path__ + "static/media/home-hero-full.88d02732.svg";